import { UX2 } from '@wsb/guac-widget-core';

const getTCCLString = UX2.utils.TCCLUtils.getTCCLString;

export default {
  PREV_BTN_EID: 'ux2.pdf.prev_button.click',
  NEXT_BTN_EID: 'ux2.pdf.next_button.click',
  DOWNLOAD_LINK_TCCL_STRING: getTCCLString({
    eid: 'ux2.pdf.download_link.click',
    type: 'click'
  }),
  triggerPreviewImpression: (pageNum, numPages, isHorizontal) => {
    if (window && window._trfq && window.trackingEnabledForType?.('impression')) {
      window._trfq.push([
        'cmdLogEvent',
        'impression',
        'ux2.pdf.preview.impression',
        [
          ['pageNum', `${pageNum}`],
          ['numPages', `${numPages}`],
          ['layout', isHorizontal ? 'horizontal' : 'vertical']
        ]
      ]);
    }
  },
  triggerPageTransition: (eid, pageNum, numPages, isHorizontal) => {
    if (window && window._trfq && window.trackingEnabledForType?.('click')) {
      window._trfq.push([
        'cmdLogEvent',
        'click',
        eid,
        [
          ['pageNum', `${pageNum}`],
          ['numPages', `${numPages}`],
          ['layout', isHorizontal ? 'horizontal' : 'vertical']
        ]
      ]);
    }
  }
};
